import type { FunctionItem, MenuItem } from '@/components/accordion/Accordion';
import { PERMS } from '@/features/auth/permissions/permissionKeys';

export const isSelectablePrivilege = (privilege: FunctionItem) =>
  privilege.permissionKey !== PERMS.role.permission.list;

export function collectSelectableFunctionIds(items: MenuItem[]) {
  const functionIds = new Set<string>();

  const walk = (nodes: MenuItem[]) => {
    nodes.forEach((node) => {
      node.functions.filter(isSelectablePrivilege).forEach((privilege) => functionIds.add(privilege.id));
      if (node.children.length > 0) walk(node.children);
    });
  };

  walk(items);
  return functionIds;
}
